import { defineMessages } from 'react-intl';

export default defineMessages({
    showMVRWillRunMethod: {
        id: 'ml.common.disclosure.Enter any customer reported violations. MVR has not yet been run. It will be run before purchase.',
        defaultMessage: 'Enter any customer reported violations. MVR has not yet been run. It will be run before purchase.'
    },
    showMVRViolationsFoundMethod: {
        id: 'ml.common.disclosure.We have found additional violations which were not previously listed. As a result, your quoted premium has been adjusted.',
        defaultMessage: 'We have found additional violations which were not previously listed. As a result, your quoted premium has been adjusted.'
    },
    mvrHasBeenRun: {
        id: 'ml.common.disclosure.MVR has been run.',
        defaultMessage: 'MVR has been run.'
    },
    showManualViolationMessage: {
        id: 'ml.common.disclosure.Manually add a customer-reported violation',
        defaultMessage: 'Manually add a customer-reported violation'
    },
    showMVRNoViolationsFoundRunMethod: {
        id: 'ml.common.disclosure.Enter any customer reported violations.',
        defaultMessage: 'Enter any customer reported violations.'
    },
    showMVRNoViolationsFoundRunMethodPrebind: {
        id: 'ml.common.disclosure.No additional activity has been identified.',
        defaultMessage: '{MVRHasBeenRun} No additional activity has been identified.'
    },
    manuallyAddCustomerViolation: {
        id: 'ml.common.disclosure.Manually add a customer-reported violation',
        defaultMessage: 'Manually add a customer-reported violation'
    },
    noXAvailable: {
        id: 'ml.common.disclosure.table.No-x-available',
        defaultMessage: 'No {header} found on reports.'
    },
    headerSource: {
        id: 'ml.common.disclosure.table.header.SOURCE',
        defaultMessage: 'SOURCE'
    },
    headerDate: {
        id: 'ml.common.disclosure.table.header.DATE',
        defaultMessage: 'DATE'
    },
    headerDRIVER: {
        id: 'ml.common.disclosure.table.header.DRIVER',
        defaultMessage: 'DRIVER'
    },
    headerNAME: {
        id: 'ml.common.disclosure.table.header.NAME',
        defaultMessage: 'NAME'
    },
    headerExcludedDriver: {
        id: 'ml.common.disclosure.table.header.EXCLUDED DRIVER',
        defaultMessage: 'EXCLUDED DRIVER'
    },
    headerDescription: {
        id: 'ml.common.disclosure.table.header.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    headerAmountPaid: {
        id: 'ml.common.disclosure.table.header.AMOUNT PAID',
        defaultMessage: 'AMOUNT PAID'
    },
    headerAction: {
        id: 'ml.common.disclosure.table.header.ACTION',
        defaultMessage: 'ACTION'
    },
    edit: {
        id: 'ml.common.disclosure.table.action.Edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.common.disclosure.table.action.Remove',
        defaultMessage: 'Remove'
    },
    yes: {
        id: 'ml.common.disclosure.table.action.Yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'ml.common.disclosure.table.action.No',
        defaultMessage: 'No'
    },
    customer: {
        id: 'ml.common.disclosure.table.source.CUSTOMER',
        defaultMessage: 'CUSTOMER'
    },
    report: {
        id: 'ml.common.disclosure.table.source.REPORT',
        defaultMessage: 'REPORT'
    },
    accidentsHeader: {
        id: 'ml.common.disclosure.table.header.Accidents',
        defaultMessage: 'Accidents'
    },
    claimsHeader: {
        id: 'ml.common.disclosure.table.header.Claims',
        defaultMessage: 'Claims'
    },
    violationsHeader: {
        id: 'ml.common.disclosure.table.header.Violations',
        defaultMessage: 'Violations'
    },
    lossesHeader: {
        id: 'ml.common.disclosure.table.header.Home Losses',
        defaultMessage: 'Home Losses'
    },
    addAccidentsButtonText: {
        id: 'ml.common.disclosure.button.ADD AN ACCIDENT',
        defaultMessage: 'ADD AN ACCIDENT'
    },
    addClaimsButtonText: {
        id: 'ml.common.disclosure.button.ADD A CLAIM',
        defaultMessage: 'ADD A CLAIM'
    },
    addViolationsButtonText: {
        id: 'ml.common.disclosure.button.ADD A VIOLATION',
        defaultMessage: 'ADD A VIOLATION'
    },
    addHomeLossesButtonText: {
        id: 'ml.common.disclosure.button.ADD A HOME LOSS',
        defaultMessage: 'ADD A HOME LOSS'
    },
    addAccidentsPopupTitle: {
        id: 'ml.common.disclosure.add.header.Add an Accident',
        defaultMessage: 'Add an Accident'
    },
    addClaimsPopupTitle: {
        id: 'ml.common.disclosure.add.header.Add a Claim',
        defaultMessage: 'Add a Claim'
    },
    addViolationsPopupTitle: {
        id: 'ml.common.disclosure.add.header.Add a Violation',
        defaultMessage: 'Add a Violation'
    },
    addHomeLossesPopupTitle: {
        id: 'ml.common.disclosure.add.header.Add a Home Loss',
        defaultMessage: 'Add a Home Loss'
    },
    editAccidentsPopupTitle: {
        id: 'ml.common.disclosure.edit.header.Edit Accident',
        defaultMessage: 'Edit Accident'
    },
    editClaimsPopupTitle: {
        id: 'ml.common.disclosure.edit.header.Edit Claim',
        defaultMessage: 'Edit Claim'
    },
    editViolationsPopupTitle: {
        id: 'ml.common.disclosure.edit.header.Edit Violation',
        defaultMessage: 'Edit Violation'
    },
    editHomeLossesPopupTitle: {
        id: 'ml.common.disclosure.edit.header.Edit Home Loss',
        defaultMessage: 'Edit Home Loss'
    },
    removeAccidentsPopupTitle: {
        id: 'ml.common.disclosure.remove.header.Remove Accident',
        defaultMessage: 'Remove Accident'
    },
    removeClaimsPopupTitle: {
        id: 'ml.common.disclosure.remove.header.Remove Claim',
        defaultMessage: 'Remove Claim'
    },
    removeViolationsPopupTitle: {
        id: 'ml.common.disclosure.remove.header.Remove Violation',
        defaultMessage: 'Remove Violation'
    },
    removeHomeLossesPopupTitle: {
        id: 'ml.common.disclosure.remove.header.Remove Home Loss',
        defaultMessage: 'Remove Home Loss'
    },
    actionPopupDescription: {
        id: 'ml.common.disclosure.action.Description',
        defaultMessage: 'Description'
    },
    actionPopupAmountPaid: {
        id: 'ml.common.disclosure.action.Amount Paid',
        defaultMessage: 'Amount Paid'
    },
    actionPopupClassification: {
        id: 'ml.common.disclosure.action.Classification',
        defaultMessage: 'Classification'
    },
    accidentsPopupDateField: {
        id: 'ml.common.disclosure.action.dateField.Accident Date',
        defaultMessage: 'Accident Date'
    },
    claimsPopupDateField: {
        id: 'ml.common.disclosure.action.dateField.Claim Date',
        defaultMessage: 'Claim Date'
    },
    violationsPopupDateField: {
        id: 'ml.common.disclosure.action.dateField.Violation Date',
        defaultMessage: 'Violation Date'
    },
    homeLossesPopupDateField: {
        id: 'ml.common.disclosure.action.dateField.Home Loss Date',
        defaultMessage: 'Home Loss Date'
    },
    accidentsPopupOwnerField: {
        id: 'ml.common.disclosure.action.OwnerField.Driver',
        defaultMessage: 'Driver'
    },
    claimsPopupOwnerField: {
        id: 'ml.common.disclosure.action.OwnerField.Driver',
        defaultMessage: 'Driver'
    },
    violationsPopupOwnerField: {
        id: 'ml.common.disclosure.action.OwnerField.Driver',
        defaultMessage: 'Driver'
    },
    homeLossesPopupOwnerField: {
        id: 'ml.common.disclosure.action.OwnerField.Name',
        defaultMessage: 'Name'
    },
    accidentsPopupEditReasonField: {
        id: 'ml.common.disclosure.action.ReasonField.Reason for editing accident',
        defaultMessage: 'Reason for editing accident'
    },
    claimsPopupEditReasonField: {
        id: 'ml.common.disclosure.action.ReasonField.Reason for editing claim',
        defaultMessage: 'Reason for editing claim'
    },
    violationsPopupEditReasonField: {
        id: 'ml.common.disclosure.action.ReasonField.Reason for editing violation',
        defaultMessage: 'Reason for editing violation'
    },
    homeLossesPopupEditReasonField: {
        id: 'ml.common.disclosure.action.ReasonField.Reason for editing home loss',
        defaultMessage: 'Reason for editing home loss'
    },
    accidentsPopupRemoveReasonField: {
        id: 'ml.common.disclosure.action.ReasonField.Reason for removing accident',
        defaultMessage: 'Reason for removing accident'
    },
    claimsPopupRemoveReasonField: {
        id: 'ml.common.disclosure.action.ReasonField.Reason for removing claim',
        defaultMessage: 'Reason for removing claim'
    },
    violationsPopupRemoveReasonField: {
        id: 'ml.common.disclosure.action.ReasonField.Reason for removing violation',
        defaultMessage: 'Reason for removing violation'
    },
    homeLossesPopupRemoveReasonField: {
        id: 'ml.common.disclosure.action.ReasonField.Reason for removing home loss',
        defaultMessage: 'Reason for removing home loss'
    },
    duplicateDisclosureAlert: {
        id: 'ml.common.disclosure.action.ReasonField.Duplicate Disclosure',
        defaultMessage: 'Activity already exists with matching details.'
    },
    weatherLossNo: {
        id: 'ml.common.disclosure.weatherLoss.No',
        defaultMessage: 'N'
    },
    weatherLossYes: {
        id: 'ml.common.disclosure.weatherLoss.Yes',
        defaultMessage: 'Y'
    },
       helpTextTitle: {
        id: 'ml.common.disclosure.table.header.WEATHERLOSS.helpTextTitle',
        defaultMessage: 'Was the cause of loss weather related, such as but not limited to, hail, flood, or tornado?'
    },
        helpText: {
        id: 'ml.common.disclosure.table.header.WEATHERLOSS.helpText',
        defaultMessage: 'Comprehensive losses caused by weather will not be used in policy rating.'
    },
});